import { colors } from "@material-ui/core";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "@/destinations/configs/shared/ConfigPageRow";

export function BaseConfigurationModal({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["accountId", "customerId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
}

export function BaseConfigurationRow({ setConfigModalOpen, existingConfig }) {
  const settings = existingConfig.settings || {};

  const hasAccountId = "accountId" in settings;
  const hasCustomerId = "customerId" in settings;
  const isAccountIdNumeric = hasAccountId && /^\d+$/.test(settings.accountId);
  const isCustomerIdNumeric =
    hasCustomerId && /^\d+$/.test(settings.customerId);

  const isValid =
    hasAccountId && hasCustomerId && isAccountIdNumeric && isCustomerIdNumeric;

  let labelText = "Configured";
  if (!hasAccountId || !hasCustomerId) {
    labelText = "Not configured";
  } else if (!isAccountIdNumeric && !isCustomerIdNumeric) {
    labelText = "Account ID and Customer ID must be numeric";
  } else if (!isAccountIdNumeric) {
    labelText = "Account ID must be numeric";
  } else if (!isCustomerIdNumeric) {
    labelText = "Customer ID must be numeric";
  }

  return (
    <DestinationConfigRow
      name="Base configuration"
      textColor={isValid ? "" : colors.red[600]}
      labelText={labelText}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
}
